import type { TripListPrice } from './tripListTypes'
import { computeCartPanelTotal } from '../../utils/cartPanelUtils'

export interface TripListFooterTotalPrice {
  total: number
  currency: string
}

export function getTripListFooterTotalPrice(prices: Array<TripListPrice>, luxPlusEnabled: boolean): TripListFooterTotalPrice | undefined {
  let currency: string | undefined
  const totalItems = []

  for (const price of prices) {
    const totalPrice = price.totalPrice ?? price.price
    if (totalPrice === undefined || !price.currency) continue
    if (currency && currency !== price.currency) return undefined
    currency = price.currency
    totalItems.push({
      cartExcluded: false,
      price: totalPrice,
      memberPrice: price.totalPrice !== undefined ? price.totalMemberPrice : price.memberPrice,
      includeInTotal: true,
      includeInCount: true,
    })
  }

  if (!currency) return undefined

  return {
    total: computeCartPanelTotal(totalItems, luxPlusEnabled).totalPrice,
    currency,
  }
}
